import filter from 'lodash/filter'
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';

import {connect} from '~/redux/connect';

import {
    presentAllMessages, presentAllErrors
} from "~/stateGetter";
import {modelActionsCreator} from "~/actions/model_actions";
import getConfig from "~/config";
import MessageList from "~/ui/components/MessageList/MessageList";


const areStatePropsEqual = (props, prevProps) => {
    return isEqual(props, prevProps);
};

const RXMessageList = connect(
    (state, {modelId, messageSources = []}) => {
        return {
            messages: presentAllMessages(state, modelId, uniq([...messageSources, ...getConfig().messageSources])),
            errors: presentAllErrors(state, modelId, getConfig().errorSources),
        }
    },
    (dispatch, {modelId}) => {
        let { hideMessages } = modelActionsCreator(modelId);

        return {
            hideMessages: () => dispatch(hideMessages()),
        };
    },

    ({ messages, errors, ...otherProps }, dispatcher, {filterMessages, messageSources, scope = 'local', ...otherOwnProps}) => {
        let filterTheMessages = (messages) => {
            // console.log('before filter', messages);

            messages = uniqBy(messages, 'message');
            messages = filter(messages, (message) => message && message.message.length && (message.scope === 'local' || message.scope === scope));
            messages = filterMessages ? filterMessages(messages) : messages;

            // console.log('after filter', messages);

            // Last message should is displayed above.
            return messages.sort((a, b) => a.created_at - b.created_at).reverse().map((message) => ({
                ...message,
                type: message.status || message.type,
            }));
        };

        return {
            ...otherProps,
            ...otherOwnProps,
            ...dispatcher,
            messages: orderBy(filterTheMessages([
                ...messages,
                ...errors
            ]),'status'),
        }
    }, { areStatePropsEqual }
)(MessageList);

export default RXMessageList;